"use client";

export default function PrivacyPolicy() {
	return (
		<div className="min-h-full bg-mgt-black px-4 py-8 md:py-12">
			<div className="max-w-4xl mx-auto">
				<div className="text-center mb-12">
					<h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
						Privacy Policy
					</h1>
					<p className="text-off-white text-lg">
						Your privacy and data protection on MyGeoTokens
					</p>
				</div>

				<div className="bg-brown rounded-2xl p-6 md:p-8 space-y-8 text-white">
					<section>
						<h2 className="text-2xl font-bold text-mgt-green mb-4">
							1. Information We Collect
						</h2>
						<div className="space-y-4">
							<div>
								<h3 className="text-lg font-semibold text-white mb-2">
									Account Information
								</h3>
								<p className="text-off-white leading-relaxed">
									When you create an account, we collect your email address,
									username, phone number, and profile information including age
									and gender preferences.
								</p>
							</div>
							<div>
								<h3 className="text-lg font-semibold text-white mb-2">
									Location Data
								</h3>
								<p className="text-off-white leading-relaxed">
									We collect precise location data when you drop or interact
									with NFTs to enable our geospatial features. This data is
									essential for the core functionality of our platform.
								</p>
							</div>
							<div>
								<h3 className="text-lg font-semibold text-white mb-2">
									Blockchain Data
								</h3>
								<p className="text-off-white leading-relaxed">
									We record your public wallet address and transaction history
									on the Solana blockchain. This information is publicly
									available on the blockchain.
								</p>
							</div>
						</div>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-mgt-green mb-4">
							2. How We Use Your Information
						</h2>
						<ul className="list-disc list-inside text-off-white space-y-2 ml-4">
							<li>Provide and improve our geospatial NFT services</li>
							<li>Process transactions and manage your account</li>
							<li>Send important updates about our platform</li>
							<li>Ensure platform security and prevent fraud</li>
							<li>Comply with legal obligations</li>
						</ul>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-mgt-green mb-4">
							3. Web3 and Blockchain Privacy
						</h2>
						<div className="space-y-4">
							<p className="text-off-white leading-relaxed">
								As a Web3 application, certain aspects of your activity are
								inherently public:
							</p>
							<ul className="list-disc list-inside text-off-white space-y-2 ml-4">
								<li>All blockchain transactions are publicly visible</li>
								<li>Your wallet address and NFT holdings are on-chain</li>
								<li>We cannot delete or modify blockchain data</li>
								<li>
									Smart contract interactions are permanent and transparent
								</li>
							</ul>
						</div>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-mgt-green mb-4">
							4. Data Sharing and Disclosure
						</h2>
						<div className="space-y-4">
							<p className="text-off-white leading-relaxed mb-4">
								We do not sell your personal information. We may share data in
								these situations:
							</p>
							<ul className="list-disc list-inside text-off-white space-y-2 ml-4">
								<li>With your explicit consent</li>
								<li>To comply with legal requirements</li>
								<li>To protect our rights and prevent fraud</li>
								<li>With service providers who assist our operations</li>
								<li>In connection with a business transaction</li>
							</ul>
						</div>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-mgt-green mb-4">
							5. Data Security
						</h2>
						<p className="text-off-white leading-relaxed mb-4">
							We implement industry-standard security measures to protect your
							data:
						</p>
						<ul className="list-disc list-inside text-off-white space-y-2 ml-4">
							<li>Encrypted data transmission and storage</li>
							<li>Regular security audits and updates</li>
							<li>Access controls and authentication systems</li>
							<li>Secure cloud infrastructure</li>
						</ul>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-mgt-green mb-4">
							6. Your Rights and Choices
						</h2>
						<div className="space-y-4">
							<p className="text-off-white leading-relaxed mb-4">
								You have the following rights regarding your personal data:
							</p>
							<ul className="list-disc list-inside text-off-white space-y-2 ml-4">
								<li>Access and review your personal information</li>
								<li>Update or correct inaccurate data</li>
								<li>Request deletion of your account data</li>
								<li>Opt out of marketing communications</li>
								<li>Data portability where technically feasible</li>
							</ul>
							<p className="text-off-white leading-relaxed mt-4">
								Note: Blockchain data cannot be deleted or modified due to the
								immutable nature of distributed ledgers.
							</p>
						</div>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-mgt-green mb-4">
							7. Cookies and Tracking
						</h2>
						<p className="text-off-white leading-relaxed">
							We use essential cookies to maintain your login session and
							preferences. We do not use tracking cookies for advertising
							purposes. You can manage cookie preferences in your browser
							settings.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-mgt-green mb-4">
							8. Third-Party Services
						</h2>
						<p className="text-off-white leading-relaxed mb-4">
							Our platform integrates with third-party services that have their
							own privacy policies:
						</p>
						<ul className="list-disc list-inside text-off-white space-y-2 ml-4">
							<li>Solana blockchain network</li>
							<li>Wallet providers (MGT Wallet, Solflare, etc.)</li>
							<li>Mapping services for location features</li>
							<li>Cloud storage and infrastructure providers</li>
						</ul>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-mgt-green mb-4">
							9. International Data Transfers
						</h2>
						<p className="text-off-white leading-relaxed">
							Your data may be transferred to and processed in countries other
							than your residence. We ensure appropriate safeguards are in place
							for international transfers in compliance with applicable data
							protection laws.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-mgt-green mb-4">
							10. Children&apos;s Privacy
						</h2>
						<p className="text-off-white leading-relaxed">
							Our platform is not intended for users under 18. We do not
							knowingly collect personal information from children. If we
							discover we have collected data from a minor, we will delete it
							promptly.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-mgt-green mb-4">
							11. Data Retention
						</h2>
						<p className="text-off-white leading-relaxed">
							We retain your personal data only as long as necessary for the
							purposes outlined in this policy, to comply with legal
							obligations, or to resolve disputes. Account data is typically
							deleted within 30 days of account closure, except for blockchain
							data which is permanent.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-mgt-green mb-4">
							12. Policy Updates
						</h2>
						<p className="text-off-white leading-relaxed">
							We may update this privacy policy periodically. Significant
							changes will be communicated via email or platform notifications.
							Your continued use of our services constitutes acceptance of any
							updates.
						</p>
					</section>

					<section>
						<h2 className="text-2xl font-bold text-mgt-green mb-4">
							13. Contact Us
						</h2>
						<p className="text-off-white leading-relaxed">
							For privacy-related questions or to exercise your rights, contact
							us at{" "}
							<a
								href="mailto:privacy@mygeotokens.com"
								className="text-mgt-green hover:text-mgt-yellow transition-colors"
							>
								privacy@mygeotokens.com
							</a>
						</p>
					</section>

					<div className="border-t border-off-white/20 pt-6 mt-8">
						<p className="text-sm text-off-white text-center">
							Last updated: May 11, 2026
						</p>
						<p className="text-sm text-off-white text-center mt-2">
							© {new Date().getFullYear()} MyGeoTokens Inc. All rights reserved.
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}
